import React, { useEffect, useRef } from 'react';
import { IoIosNotifications } from 'react-icons/io';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import DropdownNavbar from './DropdownNavbar';
import logoUser from '../imgs/user-128.png';
import DropdownNotification from './DropdownNotification';

const Navbar = ({ closeDropdown, closeNotification, closeSidebar, height, setHeight, height2, setHeight2, links, showSidebar, setShowSidebar }) => {

    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const profile = useSelector(state => state.user.user.data);
    const avatarUrl = useSelector(state => state.user.user.avatarUrl);
    const notifies = useSelector(state => state.notification.list);
    const location = useLocation();

    let dropdownRef = useRef();
    const sidebarRef = useRef();
    const notifyRef = useRef();

    //--------------------------------UseEffect to close dropdown-----------------
    useEffect(() => {
        /**
         * If the dropdown menu is open and the user clicks outside of the dropdown, close the dropdown menu.
         */
        let handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                closeDropdown()
            }
        }
        document.addEventListener("mousedown", handler, height === "auto")
        return document.removeEventListener("mousedown", handler, height === 0);
    })

    //------------------------------UseEffect to close Sidebar--------------------
    useEffect(() => {
        /**
         * If the sidebar is open and the user clicks outside of the sidebar, close the sidebar.
         */
        let onClick = (e) => {
            if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
                closeSidebar();
            }
        }
        document.addEventListener('mousedown', onClick,);
        return () => {
            document.removeEventListener('mousedown', onClick, true);
        }
    })

    //------------------------------UseEffect to close Notification--------------------
    useEffect(() => {
        let onClick = (e) => {
            if (notifyRef.current && !notifyRef.current.contains(e.target)) {
                closeNotification();
            }
        }
        document.addEventListener('mousedown', onClick);
        return () => {
            document.removeEventListener('mousedown', onClick)
        }
    })

    return (
        <>
            <div className='navbar container'>
                <Link to='/' className='logo'>F<span>oo</span>dRecipe</Link>

                <div className='nav-links'>
                    <div className='nav-links-items'>
                        {[links[0], links[1]].map(link => (
                            <Link
                                to={link.path}
                                key={link.name}
                                className={location.pathname === link.path ? "active" : ""}
                            >
                                {link.name}
                            </Link>
                        ))}
                    </div>
                    <div className='nav-links-main'>
                        {currentUser ?
                            <div ref={dropdownRef}>
                                {profile &&
                                    <>
                                        <div className="notification_container"
                                            ref={notifyRef}
                                        >
                                            <div className="notification_icon"
                                                title='Notification'
                                                onClick={() => setHeight2(height2 === 0 ? "auto" : 0)}
                                            >
                                                <IoIosNotifications />
                                                <span className="count_notify">{[...notifies].length}</span>
                                            </div>
                                            <DropdownNotification height2={height2} closeNotification={closeNotification} />
                                        </div>
                                        <img src={avatarUrl ? avatarUrl : logoUser}
                                            alt=''
                                            className='user-pic'
                                            title='Profile'
                                            aria-expanded={height !== 0}
                                            onClick={() => setHeight(height === 0 ? "auto" : 0)}
                                        />
                                        <DropdownNavbar height={height} currentUser={profile} closeDropdown={closeDropdown} />
                                    </>}
                            </div> :
                            <>
                                {[links[5], links[2], links[3]].map(link => (
                                    <Link
                                        to={link.path}
                                        key={link.name}
                                        className={location.pathname === link.path ? "active" : ""}
                                    >
                                        {link.name}
                                    </Link>
                                ))}
                            </>
                        }
                    </div>
                </div>
                <div
                    ref={sidebarRef}
                    onClick={() => setShowSidebar(!showSidebar)}
                    className={showSidebar ? "sidebar-btn active" : "sidebar-btn"}
                >
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </div>
            <div ref={sidebarRef}>
                {showSidebar && <Sidebar closeSidebar={closeSidebar} links={links} />}
            </div>
        </>
    )
}

export default Navbar
